import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Old links (/dashboard and the retired mockup pages) open the user's landing page.
 * Waits for the executive flag first: a session saved before the flag existed has none.
 */
export const landingRedirectGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth
    .resolveExecutiveAccess()
    .pipe(map(() => router.createUrlTree([auth.getLandingRoute()])));
};

/**
 * Every page in the app shell: a user whose landing is access pending (no order role,
 * no executive access, not an admin) is sent there, with no toast. Pages marked
 * `data: { openWithoutRole: true }` (the own profile) stay open.
 */
export const accessPendingGuard: CanActivateChildFn = (route) => {
  if (route.data['openWithoutRole'] === true) return true;
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.resolveExecutiveAccess().pipe(
    map(() => {
      const landing = auth.getLandingRoute();
      return landing !== '/access-pending' || router.createUrlTree([landing]);
    })
  );
};
